import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

/* helper */
const formatCompany = (name) => {
    if (!name) return "ClassWalla";
    return decodeURIComponent(name).replace(/[-_]+/g, " ");
};

export default function AccountDeletionForm() {
    const { company, comId, type } = useParams();
    const companyName = formatCompany(company);

    const [submitted, setSubmitted] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        if (!company) {
            window.location.href = "https://classwalla.com";
            return;
        }
        document.title = companyName + " - Account Deletion";
    }, [company, companyName]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const form = e.target;
        const phone = form.phone.value;
        const confirm = form.confirm.value;
        if (confirm !== 'yes') {
            window.location.href = "https://classwalla.com";
            return;
        }

        const requestData = {
            data: {
                companyId: comId,
                mobile: phone,
                request_type: type
            }
        };

        try {
            const response = await sendToBackend(requestData);
            if (response.error === false) {
                setSubmitted(true);
            } else {
                setError(response.message);
            }
        } catch (err) {
            console.error("Error:", err);
            setError("Failed to submit request. Please try again or contact support at support@classwalla.com");
        } finally {
            setLoading(false);
        }
    };

    const sendToBackend = async (requestData) => {
        const API_ENDPOINT = "https://backend.classwalla.com/misc/misc/studentRequests";

        const form = new FormData();
        form.append("body", JSON.stringify(requestData));

        const res = await fetch(API_ENDPOINT, {
            method: "POST",
            body: form,
        });

        return res.json();
    };


    if (submitted) {
        return React.createElement(
            "div",
            {
                style: {
                    padding: 32,
                    background: "#f7f9fb",
                    minHeight: "100vh",
                    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }
            },
            React.createElement(
                "div",
                {
                    style: {
                        maxWidth: 600,
                        background: "#fff",
                        padding: 28,
                        borderRadius: 10,
                        textAlign: "center"
                    }
                },
                React.createElement("h1", null, "Thank You!"),
                React.createElement(
                    "div",
                    {
                        style: {
                            fontSize: 48,
                            color: "#10b981",
                            marginBottom: 16
                        }
                    },
                    "✓"
                ),
                React.createElement(
                    "p",
                    { style: { lineHeight: 1.6, fontSize: 18 } },
                    "Your account deletion request for ",
                    React.createElement("strong", null, companyName),
                    " has been received."
                ),
                React.createElement(
                    "p",
                    { style: { lineHeight: 1.6, marginTop: 16, color: "#4b5563" } },
                    "Our team will process your request and contact you using the phone number provided."
                ),
                React.createElement(
                    "div",
                    {
                        style: {
                            marginTop: 24,
                            padding: 16,
                            background: "#f3f4f6",
                            borderRadius: 8,
                            textAlign: "left"
                        }
                    },
                    React.createElement(
                        "p",
                        { style: { fontWeight: 600, marginBottom: 8 } },
                        "Next Steps:"
                    ),
                    React.createElement(
                        "ol",
                        { style: { paddingLeft: 20, lineHeight: 1.6 } },
                        React.createElement("li", null, "Our team will verify your request"),
                        React.createElement("li", null, "We will contact you via phone for confirmation"),
                        React.createElement("li", null, "Your account will be marked for deletion"),
                        React.createElement("li", null, "All data will be permanently deleted after 30 days")
                    )
                )
            )
        );
    }

    return React.createElement(
        "div",
        {
            style: {
                padding: 32,
                background: "#f7f9fb",
                minHeight: "100vh",
                fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'"
            }
        },
        React.createElement(
            "div",
            {
                style: {
                    maxWidth: 800,
                    margin: "auto",
                    background: "#fff",
                    padding: 28,
                    borderRadius: 10,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }
            },
            React.createElement(
                "div",
                {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 20,
                        paddingBottom: 20,
                        borderBottom: "1px solid #e5e7eb"
                    }
                },
                React.createElement(
                    "div",
                    {
                        style: {
                            width: 48,
                            height: 48,
                            background: "#dc2626",
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 16
                        }
                    },
                    React.createElement(
                        "span",
                        {
                            style: {
                                color: "white",
                                fontSize: 20,
                                fontWeight: "bold"
                            }
                        },
                        "!"
                    )
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "h1",
                        {
                            style: {
                                margin: 0,
                                fontSize: 24,
                                color: "#1f2937"
                            }
                        },
                        "Account Deletion Request"
                    ),
                    React.createElement(
                        "p",
                        {
                            style: {
                                margin: "4px 0 0 0",
                                color: "#6b7280",
                                fontSize: 14
                            }
                        },
                        companyName
                    )
                )
            ),

            React.createElement(
                "p",
                { style: { lineHeight: 1.6, color: "#4b5563" } },
                "This form allows you to request deletion of your ",
                React.createElement("strong", null, companyName),
                " account and associated data."
            ),

            React.createElement(
                "div",
                {
                    style: {
                        background: "#fef2f2",
                        borderLeft: "4px solid #dc2626",
                        padding: "16px 20px",
                        margin: "20px 0",
                        borderRadius: "0 4px 4px 0"
                    }
                },
                React.createElement(
                    "p",
                    { style: { fontWeight: 600, color: "#7f1d1d", margin: "0 0 8px 0" } },
                    "Important Information"
                ),
                React.createElement(
                    "ul",
                    {
                        style: {
                            margin: 0,
                            paddingLeft: 20,
                            lineHeight: 1.6,
                            color: "#991b1b"
                        }
                    },
                    React.createElement(
                        "li",
                        null,
                        "Our team will contact you using the phone number provided"
                    ),
                    React.createElement(
                        "li",
                        null,
                        "Account data remains available for 30 days after deletion"
                    ),
                    React.createElement(
                        "li",
                        null,
                        "Data is permanently deleted after 30 days"
                    ),
                    React.createElement(
                        "li",
                        null,
                        "This action cannot be undone"
                    )
                )
            ),

            error && React.createElement(
                "div",
                {
                    style: {
                        backgroundColor: "#fee2e2",
                        color: "#dc2626",
                        padding: "12px 16px",
                        borderRadius: 6,
                        marginBottom: 20,
                        border: "1px solid #fecaca",
                        display: "flex",
                        alignItems: "center"
                    }
                },
                React.createElement(
                    "span",
                    {
                        style: {
                            marginRight: 8,
                            fontSize: 18
                        }
                    },
                    "⚠"
                ),
                error
            ),

            React.createElement(
                "form",
                {
                    onSubmit: handleSubmit,
                    style: { marginTop: 24 }
                },
                // Phone number field
                React.createElement(
                    "div",
                    { style: { marginBottom: 32 } },
                    React.createElement(
                        "label",
                        {
                            htmlFor: "phone",
                            style: {
                                display: "block",
                                fontWeight: 600,
                                marginBottom: 8,
                                color: "#374151"
                            }
                        },
                        "Phone Number Associated with Account *"
                    ),
                    React.createElement("input", {
                        type: "tel",
                        id: "phone",
                        name: "phone",
                        required: true,
                        placeholder: "e.g. 9876543210",
                        pattern: "[0-9]{10}",
                        title: "Please enter a 10-digit phone number",
                        style: {
                            width: "100%",
                            padding: "12px 16px",
                            borderRadius: 6,
                            border: "1px solid #d1d5db",
                            fontSize: 16,
                            boxSizing: "border-box"
                        }
                    }),
                    React.createElement(
                        "small",
                        {
                            style: {
                                display: "block",
                                marginTop: 4,
                                color: "#6b7280",
                                fontSize: 14
                            }
                        },
                        "We will contact you on this number for verification"
                    )
                ),

                // Confirmation
                React.createElement(
                    "div",
                    { style: { marginBottom: 32 } },
                    React.createElement(
                        "label",
                        {
                            style: {
                                display: "block",
                                fontWeight: 600,
                                marginBottom: 12,
                                color: "#374151"
                            }
                        },
                        "Confirmation *"
                    ),

                    React.createElement(
                        "div",
                        {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 12
                            }
                        },
                        React.createElement(
                            "label",
                            {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "12px 16px",
                                    border: "2px solid #d1d5db",
                                    borderRadius: 6,
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                }
                            },
                            React.createElement("input", {
                                type: "radio",
                                name: "confirm",
                                value: "yes",
                                required: true,
                                style: {
                                    marginRight: 12,
                                    transform: "scale(1.2)"
                                }
                            }),
                            React.createElement(
                                "div",
                                null,
                                React.createElement(
                                    "div",
                                    { style: { fontWeight: 600 } },
                                    "Yes, delete my account permanently"
                                ),
                                React.createElement(
                                    "div",
                                    { style: { fontSize: 14, color: "#6b7280", marginTop: 4 } },
                                    "I understand this action cannot be undone"
                                )
                            )
                        ),

                        React.createElement(
                            "label",
                            {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "12px 16px",
                                    border: "2px solid #d1d5db",
                                    borderRadius: 6,
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                }
                            },
                            React.createElement("input", {
                                type: "radio",
                                name: "confirm",
                                value: "no",
                                required: true,
                                style: {
                                    marginRight: 12,
                                    transform: "scale(1.2)"
                                }
                            }),
                            React.createElement(
                                "div",
                                null,
                                React.createElement(
                                    "div",
                                    { style: { fontWeight: 600 } },
                                    "No, I changed my mind"
                                ),
                                React.createElement(
                                    "div",
                                    { style: { fontSize: 14, color: "#6b7280", marginTop: 4 } },
                                    "I want to keep my account"
                                )
                            )
                        )
                    )
                ),

                // Submit button
                React.createElement(
                    "div",
                    {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingTop: 24,
                            borderTop: "1px solid #e5e7eb"
                        }
                    },
                    React.createElement(
                        "button",
                        {
                            type: "submit",
                            disabled: loading,
                            style: {
                                padding: "14px 32px",
                                background: loading ? "#9ca3af" : "#dc2626",
                                color: "#fff",
                                border: "none",
                                borderRadius: 6,
                                fontSize: 16,
                                fontWeight: 600,
                                cursor: loading ? "not-allowed" : "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                transition: "all 0.2s"
                            }
                        },
                        loading && React.createElement(
                            "span",
                            {
                                style: {
                                    width: 16,
                                    height: 16,
                                    border: "2px solid #fff",
                                    borderTop: "2px solid transparent",
                                    borderRadius: "50%",
                                    animation: "spin 1s linear infinite",
                                    display: "inline-block"
                                }
                            }
                        ),
                        loading ? "Submitting..." : "Submit Deletion Request"
                    ),
                    React.createElement(
                        "a",
                        {
                            href: "https://classwalla.com",
                            style: {
                                color: "#6b7280",
                                textDecoration: "none",
                                fontSize: 14
                            }
                        },
                        "Cancel"
                    )
                )
            ),

            React.createElement(
                "div",
                {
                    style: {
                        marginTop: 32,
                        paddingTop: 20,
                        borderTop: "1px solid #e5e7eb",
                        fontSize: 14,
                        color: "#6b7280"
                    }
                },
                React.createElement(
                    "p",
                    { style: { margin: "0 0 8px 0" } },
                    React.createElement("strong", null, "Need help?"),
                    " Contact our support team at support@classwalla.com"
                ),
                React.createElement(
                    "p",
                    { style: { margin: 0 } },
                    "We process deletion requests within 24-48 hours during business days."
                )
            ),

            React.createElement(
                "style",
                null,
                `
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    input:focus, button:focus {
                        outline: none;
                        box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
                    }
                    label:hover input[type="radio"] {
                        border-color: #dc2626;
                    }
                `
            )
        )
    );
}